export const EntityGeometry = `
    entitygeometry {
        objectid
        fid2
        geoType
        type
        fullUid
        theGeom
    }
`;
